import { createContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import {
  getFailureRequestsService,
  getFailureRequestService,
  deleteFailureRequestService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const failureRequestsAdminContext = createContext({
  codes: [],
  setCodes: () => {},
  failureRequest: {},
  setFailureRequest: () => {},
  search: "",
  setSearch: () => {},
  to_date: "",
  setTo_date: () => {},
  from_date: "",
  setFrom_date: () => {},
  status: "",
  setStatus: () => {},
  isShowAdvancedSearch: null,
  setIsShowAdvancedSearch: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleCloseFailureRequestModal: () => {},
  handleGetFailureRequests: () => {},
  handleGetFailureRequest: () => {},
  handleDeleteFailureRequest: () => {},
  handleDateRange: () => {},
});

const FailureRequestsAdminContext = ({ children, isUser = false }) => {
  // Redux Dispatch
  const dispatch = useDispatch();
  const allCities = useSelector((state) => state.cities);

  const [failureRequests, setFailureRequests] = useState([]);
  const [failureRequest, setFailureRequest] = useState({});
  const [search, setSearch] = useState("");
  const [to_date, setTo_date] = useState("");
  const [from_date, setFrom_date] = useState("");
  const [status, setStatus] = useState("False");
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);
  const [isShowAdvancedSearch, setIsShowAdvancedSearch] = useState(false);
  const [city_filter, setCity_filter] = useState("");
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (allCities !== cities) {
      setCities(allCities);
    }
  }, [allCities]);

  // Handle Close Payment Transaction Modal
  const handleCloseFailureRequestModal = () => {
    setFailureRequest({});
  };

  // Handle Get FailureRequests Method
  const handleGetFailureRequests = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    const objData = {
      search,
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
      ...(status && { status }),
      ...(city_filter && { city_id: city_filter }),
      ...(to_dateVal && { to_date: `${to_dateVal} 23:59:59` }),
      ...(from_dateVal && { from_date: `${from_dateVal} 00:00:00` }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFailureRequestsService(objData);
      if (status === 200) {
        setFailureRequests(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Payment Transaction Method
  const handleGetFailureRequest = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFailureRequestService(id);
      if (status === 200) {
        setFailureRequest(data);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Payment Transaction Method
  const handleDeleteFailureRequest = async (item) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteFailureRequestService(item?.id);
      if (status === 200) {
        toastSuccessMessage(
          `تخلف ${item?.client?.first_name} ${item?.client?.last_name} با موفقیت حذف شد`
        );
        handleGetFailureRequests();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Date Range
  const handleDateRange = (days) => {
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setDate(today.getDate() - days);
    setFrom_date(fromDate.toISOString().slice(0, 10));
    setTo_date(today.toISOString().slice(0, 10));
  };

  return (
    <failureRequestsAdminContext.Provider
      value={{
        failureRequests,
        setFailureRequests,
        failureRequest,
        setFailureRequest,
        search,
        setSearch,
        to_date,
        setTo_date,
        from_date,
        setFrom_date,
        status,
        setStatus,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        isShowAdvancedSearch,
        setIsShowAdvancedSearch,
        handleCloseFailureRequestModal,
        handleGetFailureRequests,
        handleGetFailureRequest,
        handleDeleteFailureRequest,
        handleDateRange,
        city_filter,
        setCity_filter,
        cities,
      }}
    >
      {children}
    </failureRequestsAdminContext.Provider>
  );
};

export default FailureRequestsAdminContext;
